// ** React Imports
import { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// ** Redux Imports
import store from "./redux/index.ts";
import { Provider } from "react-redux";

// ** ThemeColors Context

import { ThemeContext } from "./utility/context/ThemeColors";

// ** ThemeConfig
import themeConfig from "./configs/themeConfig";

// ** Toast
import { Toaster } from "react-hot-toast";

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner";

// ** Ripple Button
import "./@core/components/ripple-button";

// ** PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-jsx.min";

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";

// ** React Hot Toast Styles
import "@styles/react/libs/react-hot-toasts/react-hot-toasts.scss";

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";
import "./languages";
import App from "./App";
import { ApplicationProvider } from "./utility/context/ApplicationContext";

// ** Service Worker
//import * as serviceWorker from "./serviceWorker";

// ** Lazy load app

import KeycloakService from "./service/keycloak.js";
import { Info } from "react-feather";
import Unavailable from "./views/Unavailable";


const container = document.getElementById("root");
// let root = null;

KeycloakService.CallInit(createRoot(container))
  .then(root => {
    root.render(
      <BrowserRouter>
        <Provider store={store}>
          <Suspense fallback={<Spinner />}>
            <ThemeContext>
              <ApplicationProvider><App /></ApplicationProvider>
              <Toaster

                position={themeConfig.layout.toastPosition}
                containerStyle={{
                  // width:"80%"
                }}
                toastOptions={{
                  id:"toast-unique-id",//para aparecer apenas um toast
                  className: "react-hot-toast",
                  error: {
                    style: {
                      border: "solid thin #D64323",
                    },
                  },
                  success: {
                    style: {
                      border: "solid thin #2C9048",
                    },
                  },
                  custom: {
                    icon: Info,
                    style: {
                      border: "solid thin #115983",
                      background: "#76AAD1"
                    },
                  }

                }}
              />
            </ThemeContext>
          </Suspense>
        </Provider>
      </BrowserRouter>
    );
  })
  .catch(error => {
    const root = createRoot(container)
    root.render(
      <BrowserRouter>
        <Provider store={store}>
          <Routes>
            <Route path="/*" element={<Unavailable />}></Route>
          </Routes>
        </Provider>
      </BrowserRouter>
    );

  }
  )






// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.register();
